import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { ActiveListTitle, ApexCharts, StarterKits, UIKits, WowAnimations } from "../../../constants";
import { ActiveListSubTitle } from "../../../data/uiKits/Lists";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const ActiveList = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ActiveListTitle} span={ActiveListSubTitle} />
        <CardBody>
          <ListGroup>
            <ListGroupItem active><i className="icofont icofont-arrow-right" /> {UIKits}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right" /> {WowAnimations}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right" /> {ApexCharts}</ListGroupItem>
            <ListGroupItem><i className="icofont icofont-arrow-right" /> {StarterKits}</ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ActiveList;
